import {Input} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {Controller, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import * as classes from './CommentInput.classes'
import type {CommentInputProps} from './CommentInput.types'

export function CommentInput({name, 'data-testid': dataTestId}: CommentInputProps): React.ReactElement {
  const t = useI18n()
  const {control} = useFormContext()

  return (
    <Controller
      control={control}
      defaultValue=""
      name={name}
      render={({field, fieldState}) => (
        <div ref={field.ref}>
          <Input
            autoCapitalize="none"
            autoComplete="__disable-autocomplete"
            className={classes.multiline}
            data-testid={dataTestId}
            error={fieldState.invalid}
            helperText={fieldState.error?.message}
            label={t('cargo.create.address.comment', 'Комментарий для курьера')}
            name={name}
            onBlur={field.onBlur}
            onChange={field.onChange}
            size="l"
            spellCheck="false"
            value={field.value?.toString()}
            variant="line"
            multiline
          />
        </div>
      )}
    />
  )
}
